module.exports = __webpack_public_path__ + "static/media/trulia-logo.dd487733.svg";